module.exports = __webpack_public_path__ + "static/media/logo.c6a175d4.png";